var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.17 12.9204C19.17 12.3885 19.1223 11.8772 19.0336 11.3862H11.97V14.2874H16.0063C15.8325 15.2249 15.3041 16.0192 14.5098 16.5511V18.4329H16.9336C18.3518 17.1272 19.17 15.2044 19.17 12.9204Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9701 20.2498C13.9951 20.2498 15.6928 19.5782 16.9336 18.4328L14.5098 16.551C13.8382 17.001 12.9791 17.2668 11.9701 17.2668C10.0166 17.2668 8.36324 15.9475 7.77344 14.1748H5.26776V16.118C6.50189 18.5692 9.03824 20.2498 11.9701 20.2498Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77335 14.1748C7.62335 13.7248 7.53815 13.2441 7.53815 12.7498C7.53815 12.2555 7.62335 11.7748 7.77335 11.3248V9.38159H5.26767C4.75977 10.3941 4.46997 11.5396 4.46997 12.7498C4.46997 13.96 4.75977 15.1055 5.26767 16.118L7.77335 14.1748Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9701 8.23299C13.0711 8.23299 14.0598 8.61137 14.8371 9.35455L16.9882 7.20338C15.6894 5.99318 13.9916 5.25 11.9701 5.25C9.03824 5.25 6.50189 6.93068 5.26776 9.38185L7.77344 11.325C8.36324 9.55232 10.0166 8.23299 11.9701 8.23299Z",
    fill: "#EA4336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a9d4ff9541ef73d74935e7db57815cb5.svg";
export { ForwardRef as ReactComponent };